
export function PhoneMask(): string {
  return '(00) 0000-0000||(00) 00000-0000';
}
